import Icon from 'components/Icon';
import classNames from 'classnames';
import {FC, useEffect, useState} from 'react';
import {SwiperClass} from 'swiper/react';
import style from './style.module.scss';

interface IProps {
    swiper?: SwiperClass;
}

export const PrevButton: FC<IProps> = ({swiper}) => {
    const [isBeginning, setIsBeginning] = useState(true);

    useEffect(() => {
        if (swiper) {
            setIsBeginning(swiper.isBeginning);

            swiper.on('transitionEnd', (sw) => {
                setIsBeginning(sw.isBeginning);
            });
        }

        return () => {
            if (swiper) {
                swiper.off('transitionEnd');
            }
        };
    }, [swiper]);

    const handleClickNext = () => {
        if (!swiper) {
            return;
        }

        swiper.slidePrev();
    };

    return (
        <button
            className={classNames(style.main, isBeginning ? style.hidden : '')}
            onClick={handleClickNext}
            type={'button'}
        >
            <Icon className={style.icon} icon={'arrow'} />
        </button>
    );
};
